import LogRocket from 'logrocket';
import * as Sentry from '@sentry/react';
import { PostHog } from 'posthog-js/react';
import { AdminUserRealm } from 'further-types/admin-user';

const shouldRunTracking = () => process.env.REACT_APP_STAGE === 'production';

export const initLogrocket = (user: {
  _id?: string;
  firstName?: string;
  lastName?: string;
  email?: string;
  roleSlug?: string;
  firm?: {
    _id?: string;
  };
}) => {
  if (user && shouldRunTracking()) {
    LogRocket.init('sq3uml/furthers-admin-panel');

    LogRocket.getSessionURL((sessionURL) => {
      Sentry.setTag('logrocketSessionURL', sessionURL);
    });

    if (user._id) {
      LogRocket.identify(user._id, {
        name: `${user.firstName} ${user.lastName}`,
        email: user.email ?? '',
        firmId: user.firm?._id ?? '',
        roleSlug: user.roleSlug ?? '',
      });
    }
  }
};

export const initSentry = () => {
  if (shouldRunTracking()) {
    Sentry.init({
      dsn: 'https://800c52120f56cfab08746fcefeb732b3@o4504655840739328.ingest.us.sentry.io/4507021992984576',
      integrations: [Sentry.browserTracingIntegration()],
      tracesSampleRate: 0,
      environment: process.env.REACT_APP_STAGE,
      release: process.env.REACT_APP_VERSION_TAG,
    });
  }
};

export const maskRequestBody = (requestBody: string) => {
  return requestBody
    .replace(/"password":\s*"[^"]*"/g, '"password": "****"')
    .replace(/"repeatpassword":\s*"[^"]*"/g, '"repeatpassword": "****"')
    .replace(/"newPassword":\s*"[^"]*"/g, '"newPassword": "****"')
    .replace(/"repeatNewPassword":\s*"[^"]*"/g, '"repeatNewPassword": "****"');
};

export const identifySentry = (user: {
  _id: string;
  firstName: string;
  lastName: string;
  email: string;
  roleSlug: string;
  firm?: {
    _id: string;
    firmName: string;
    realm?: AdminUserRealm;
  };
}) => {
  if (shouldRunTracking()) {
    Sentry.setUser({
      name: `${user.firstName} ${user.lastName}`,
      email: user.email,
      firmId: user.firm?._id,
      roleSlug: user.roleSlug,
    });
  }
};

export const identifyPosthog = (
  user: {
    _id: string;
    firstName: string;
    lastName: string;
    email: string;
    firm?: {
      _id: string;
      firmName: string;
      realm?: AdminUserRealm;
    };
  },
  posthog: PostHog,
) => {
  posthog.identify(user._id, {
    name: `${user.firstName} ${user.lastName}`,
    email: user.email,
  });
  if (user.firm?._id) {
    posthog.group('firm', user.firm?._id, {
      name: user.firm?.firmName,
      realm: user.firm?.realm ?? '',
    });
  } else {
    posthog.group('firm', 'Further', {
      name: 'Further',
      realm: AdminUserRealm.Super,
    });
  }
};
